import cloneDeep from "lodash/cloneDeep";
import lodashGet from "lodash/get";
import lodashSet from "lodash/set";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { defaultValues, type PreNominationRequestFormData } from "../constants";

interface PreNominationRequestFormMethods {
  setField<K extends keyof PreNominationRequestFormData>(
    key: K,
    val: PreNominationRequestFormData[K],
  ): void;
  setAll(data: Partial<PreNominationRequestFormData>): void;
  resetForm(): void;
}

export interface PreNominationRequestFormState
  extends PreNominationRequestFormData,
    PreNominationRequestFormMethods {}

export const usePreNominationRequestFormStore = create<PreNominationRequestFormState>()(
  persist(
    (
      set: (fn: (state: PreNominationRequestFormState) => PreNominationRequestFormState) => void,
    ) => ({
      ...defaultValues,
      setField: (key, val) =>
        set((state) => {
          if (Object.is(lodashGet(state, key), val)) {
            return state;
          }

          const newState = cloneDeep(state);
          lodashSet(newState, key, val);
          return newState;
        }),
      setAll: (data) => set((s) => ({ ...s, ...data })),
      resetForm: () => set((state) => ({ ...state, ...defaultValues })),
    }),
    { name: "pre-nomination-request-form" },
  ),
);
